import { render, staticRenderFns } from "./EditorSectionMini.vue?vue&type=template&id=a1b3d1ca&scoped=true&"
import script from "./EditorSectionMini.vue?vue&type=script&lang=ts&"
export * from "./EditorSectionMini.vue?vue&type=script&lang=ts&"
import style0 from "./EditorSectionMini.vue?vue&type=style&index=0&id=a1b3d1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b3d1ca",
  null
  
)

export default component.exports